import { Injectable } from '@angular/core';
import { WSService } from 'projects/core/src/include/service';
import { Note } from '../db/note'
@Injectable({
  providedIn: 'root'
})
export class NotesService extends WSService<Note> {

  constructor() { super("notes")}



}
